import classNames from 'classnames';
import Link from 'next/link';
import React, { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var Avatar = function Avatar(_ref) {
  var avatar = _ref.avatar,
      size = _ref.size,
      initials = _ref.initials,
      avatarLink = _ref.avatarLink;

  var _useState = useState(false),
      hasError = _useState[0],
      setHasError = _useState[1];

  var handleError = function handleError() {
    return setHasError(true);
  };

  if (!avatar || hasError) {
    return /*#__PURE__*/_jsx("span", {
      className: classNames('flex items-center justify-center rounded-full text-subkit-primary bg-subkit-alt-light font-semibold text-lg flex-none', {
        'h-8 w-8': size === 'small',
        'h-10 w-10': size === 'medium',
        'h-16 w-16': size === 'large'
      }),
      children: initials
    });
  }

  return avatarLink ? /*#__PURE__*/_jsx(Link, {
    href: avatarLink,
    passHref: true,
    children: /*#__PURE__*/_jsx("img", {
      className: classNames('rounded-full cursor-pointer', {
        'h-8 w-8': size === 'small',
        'h-10 w-10': size === 'medium',
        'h-16 w-16': size === 'large'
      }),
      src: avatar,
      alt: "User Avatar",
      onError: handleError
    })
  }) : /*#__PURE__*/_jsx("img", {
    className: classNames('rounded-full', {
      'h-8 w-8': size === 'small',
      'h-10 w-10': size === 'medium',
      'h-16 w-16': size === 'large'
    }),
    src: avatar,
    alt: "User Avatar",
    onError: handleError
  });
};
Avatar.defaultProps = {
  avatar: '',
  size: 'small'
};